@if (material) {
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <h3>{{ "forms.educationalResource.basedOnDetails.externals.title" | translate }}</h3>
    <p>{{ "forms.educationalResource.basedOnDetails.addNew.tooltip" | translate }}</p>
    @for (external of externalsArray.controls; track external; let i = $index) {
      <div formArrayName="externals">
        <div class="based-on-grid" [formGroupName]="i">
          <div class="form-group">
            <label [for]="'authorExt-' + i">
              {{ "forms.educationalResource.basedOnDetails.externals.inputs.author.label" | translate }}
            </label>
            <ng-select
              [items]="[]"
              [multiple]="true"
              [addTag]="true"
              [id]="'authorExt-' + i"
              [labelForId]="'authorExt-' + i"
              formControlName="author"
              [placeholder]="'forms.educationalResource.basedOnDetails.externals.inputs.author.placeholder' | translate"
            [attr.aria-describedby]="'author-' + i + '-help'"></ng-select>
            <small [id]="'author-' + i + '-help'" class="form-text text-muted">
              {{ "forms.helpTexts.multipleItems" | translate }}
            </small>
            @if (
              external.get('author').invalid &&
              (external.get('author').dirty || external.get('author').touched || submitted)
              ) {
              @if (external.get('author').errors.required) {
                <div>
                  <small class="text-danger">{{ "forms.common.required" | translate }}</small>
                </div>
              }
              @if (external.get('author').errors.invalidCharacters) {
                <div>
                  <small class="text-danger">{{ "forms.errors.textInput.characters" | translate }}</small>
                </div>
              }
            }
          </div>
          <div class="form-group">
            <label for="{{ 'url-' + i }}">
              {{ "forms.educationalResource.basedOnDetails.externals.inputs.link.label" | translate }}
            </label>
            <input
              type="url"
              id="{{ 'url-' + i }}"
              class="form-control"
              formControlName="url"
          [ngClass]="{
            'is-invalid':
              external.get('url').invalid && (external.get('url').dirty || external.get('url').touched || submitted)
          }" />
            @if (external.get('url').invalid && (external.get('url').dirty || external.get('url').touched || submitted)) {
              <div
                class="invalid-feedback">
                @if (external.get('url').errors.required) {
                  <div>{{ "forms.common.required" | translate }}</div>
                }
                @if (external.get('url').errors.pattern) {
                  <div>{{ "forms.common.pattern.url" | translate }}</div>
                }
                @if (external.get('url').errors.maxlength) {
                  <div>
                    {{ "forms.errors.common.maxLength" | translate: { maxLength:
                    external.get("url").errors.maxlength.requiredLength } }}
                  </div>
                }
              </div>
            }
          </div>
          <div class="form-group">
            <label for="{{ 'name-' + i }}">
              {{ "forms.educationalResource.basedOnDetails.externals.inputs.name.label" | translate }}
            </label>
            <input
              type="text"
              id="{{ 'name-' + i }}"
              class="form-control"
              formControlName="name"
          [ngClass]="{
            'is-invalid':
              external.get('name').invalid && (external.get('name').dirty || external.get('name').touched || submitted)
          }" />
            @if (
              external.get('name').invalid && (external.get('name').dirty || external.get('name').touched || submitted)
              ) {
              <div
                class="invalid-feedback">
                @if (external.get('name').errors.required) {
                  <div>{{ "forms.common.required" | translate }}</div>
                }
                @if (external.get('name').errors.invalidCharacters) {
                  <div>
                    {{ "forms.errors.textInput.characters" | translate }}
                  </div>
                }
                @if (external.get('name').errors.maxlength) {
                  <div>
                    {{ "forms.errors.common.maxLength" | translate: { maxLength:
                    external.get("name").errors.maxlength.requiredLength } }}
                  </div>
                }
              </div>
            }
          </div>
          <button type="button" class="btn btn-danger btn-delete-col" (click)="removeExternal(i)">
            {{ "forms.common.delete" | translate }}
          </button>
        </div>
      </div>
    }
    <div class="form-group">
      <button type="button" class="btn btn-gray" (click)="addExternal()">
        {{ "forms.educationalResource.basedOnDetails.addNew.button" | translate }}
      </button>
    </div>
    <div class="row">
      <div class="col">
        <button type="button" class="btn btn-gray" (click)="previous()">{{ "forms.common.previous" | translate }}</button>
      </div>
      <div class="col-auto">
        <button type="reset" class="btn btn-cancel" (click)="abort()">{{ "forms.common.abort" | translate }}</button>
      </div>
      <div class="col-auto">
        <button type="submit" class="btn btn-blue">{{ "forms.common.next" | translate }}</button>
      </div>
    </div>
  </form>
}
